module.exports = __webpack_public_path__ + "static/media/myenrollmentsimg.cf1003a4.webp";